import React, { useState, useEffect } from "react";
import axios from "axios";
import "./PerformaInvoiceForm.css";

const PerformaInvoiceForm = () => {
  const [form, setForm] = useState({
    companyName: "AG PIPE FITTING TECNOLOGY PLC",
    formNo: "OF/MAR/01",
    title: "PERFORMA INVOICE",
    issueNo: "3",
    pageNo: "Page 1 of 1",
    customerName: "",
    date: "",
    tinNo: "",
    address: "",
    phoneNo: "",
    items: [
      { sn: 1, description: "", productCode: "", unit: "", qty: "", unitPrice: "", totalPrice: "" },
    ],
    sum: "0.00",
    vat: "0.00",
    totalWithVat: "0.00",
    paymentDetails: {
      commercialBank: "1000145742653",
      abayBank: "2012111008152013",
      abysiniaBank: "16790273",
    },
    deliveryTime: "5 days",
    priceValidity: "5 days",
    downPayment: "100% cash",
    placeOfDelivery: "Factory’s store",
    preparedBy: "",
    checkedBy: "",
    approvedBy: "",
    approvalStatus: false, // Approval status field
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({ ...prevForm, [name]: value }));
  };

  const addRow = () => {
    setForm((prevForm) => ({
      ...prevForm,
      items: [
        ...prevForm.items,
        { sn: prevForm.items.length + 1, description: "", productCode: "", unit: "", qty: "", unitPrice: "", totalPrice: "" },
      ],
    }));
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...form.items];
    updatedItems[index][field] = value;

    if (field === "qty" || field === "unitPrice") {
      updatedItems[index].totalPrice = parseFloat(updatedItems[index].qty || 0) * parseFloat(updatedItems[index].unitPrice || 0);
    }

    const newSum = updatedItems.reduce((total, item) => total + parseFloat(item.totalPrice || 0), 0);
    const newVat = (newSum * 0.15).toFixed(2);
    const newTotalWithVat = (newSum + parseFloat(newVat)).toFixed(2);

    setForm((prevForm) => ({
      ...prevForm,
      items: updatedItems,
      sum: newSum.toFixed(2),
      vat: newVat,
      totalWithVat: newTotalWithVat,
    }));
  };

  const removeRow = () => {
    if (form.items.length > 1) {
      setForm((prevForm) => ({
        ...prevForm,
        items: prevForm.items.slice(0, -1),
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!form.approvalStatus) {
      alert("Request not approved by marketing manager. Cannot submit.");
      return;
    }
  
    const formData = { ...form };
    try {
      const response = await axios.post("https://agpipefitting.org.et/api/performa-invoice", formData);
      alert("Form submitted successfully!");
      console.log(response.data);
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to submit the form. Please try again.");
    }
  };
  

  useEffect(() => {
    // Fetch the client information if required.
    const fetchClientData = async () => {
      try {
        const response = await axios.get("https://agpipefitting.org.et/api/clients/1"); // Assuming client info can be fetched by ID
        setForm((prevForm) => ({
          ...prevForm,
          customerName: response.data.name,
          address: response.data.address,
          phoneNo: response.data.phoneNo,
          tinNo: response.data.tinNo,
        }));
      } catch (error) {
        console.error("Error fetching client data:", error);
      }
    };

    fetchClientData();
  }, []);

  return (
    <div className="form-container">
      <h2 className="form-title">{form.title}</h2>
      <div className="header-payment-row">
  {/* Company Info Section */}
  <div className="company-info">
    <h4>Company Information</h4>
    <p className="form-meta">
      <strong>Company Name:</strong> {form.companyName} <br />
      <strong>Form No:</strong> {form.formNo} <br />
      <strong>Issue No:</strong> {form.issueNo} <br />
      <strong>{form.pageNo}</strong>
    </p>
  </div>

  {/* Payment Details Section */}
  <div className="payment-details">
    <h4>Payment Details</h4>
    <p><strong>Commercial Bank of Ethiopia:</strong> {form.paymentDetails.commercialBank}</p>
    <p><strong>Abay Bank:</strong> {form.paymentDetails.abayBank}</p>
    <p><strong>Abysinia Bank:</strong> {form.paymentDetails.abysiniaBank}</p>
  </div>
</div>


      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="customerName">Client's Name:</label>
            <input
              type="text"
              id="customerName"
              name="customerName"
              className="form-input"
              value={form.customerName}
              onChange={handleInputChange}
              placeholder="Enter customer name"
              readOnly
            />
          </div>
          <div className="form-group">
            <label htmlFor="date">Date:</label>
            <input
              type="date"
              id="date"
              name="date"
              className="form-input"
              value={form.date}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="tinNo">TIN No:</label>
            <input
              type="text"
              id="tinNo"
              name="tinNo"
              className="form-input"
              value={form.tinNo}
              onChange={handleInputChange}
              placeholder="Enter TIN number"
            />
          </div>
        </div>

        {/* Item Table */}
        <table className="form-table">
          <thead>
            <tr>
              <th>S/N</th>
              <th>Product Description</th>
              <th>Product Code</th>
              <th>Unit</th>
              <th>Quantity</th>
              <th>Unit Price (Birr)</th>
              <th>Total Price (Birr)</th>
            </tr>
          </thead>
          <tbody>
            {form.items.map((item, index) => (
              <tr key={index}>
                <td>{item.sn}</td>
                <td>
                  <input
                    type="text"
                    className="table-input"
                    value={item.description}
                    onChange={(e) => handleItemChange(index, "description", e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="table-input"
                    value={item.productCode}
                    onChange={(e) => handleItemChange(index, "productCode", e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="table-input"
                    value={item.unit}
                    onChange={(e) => handleItemChange(index, "unit", e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    className="table-input"
                    value={item.qty}
                    onChange={(e) => handleItemChange(index, "qty", e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    className="table-input"
                    value={item.unitPrice}
                    onChange={(e) => handleItemChange(index, "unitPrice", e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    className="table-input"
                    value={item.totalPrice}
                    readOnly
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="table-controls">
          <button type="button" onClick={addRow}>Add Item</button>
          <button type="button" onClick={removeRow}>Remove Item</button>
        </div>

        <div className="summary-section">
          <div className="summary-row">
            <label htmlFor="sum">Sum:</label>
            <input type="text" id="sum" value={form.sum} readOnly />
          </div>
          <div className="summary-row">
            <label htmlFor="vat">VAT (15%):</label>
            <input type="text" id="vat" value={form.vat} readOnly />
          </div>
          <div className="summary-row">
            <label htmlFor="totalWithVat">Total with VAT:</label>
            <input type="text" id="totalWithVat" value={form.totalWithVat} readOnly />
          </div>
        </div>

        <div className="additional-info">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="deliveryTime">Delivery Time:</label>
              <input
                type="text"
                id="deliveryTime"
                name="deliveryTime"
                className="form-input"
                value={form.deliveryTime}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="placeOfDelivery">Place of Delivery:</label>
              <input
                type="text"
                id="placeOfDelivery"
                name="placeOfDelivery"
                className="form-input"
                value={form.placeOfDelivery}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="approvalStatus">Marketing Approval:</label>
              <input
                type="checkbox"
                id="approvalStatus"
                name="approvalStatus"
                checked={form.approvalStatus}
                onChange={(e) => handleInputChange(e)}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="preparedBy">Prepared By:</label>
            <input
              type="text"
              id="preparedBy"
              name="preparedBy"
              className="form-input"
              value={form.preparedBy}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="checkedBy">Checked By:</label>
            <input
              type="text"
              id="checkedBy"
              name="checkedBy"
              className="form-input"
              value={form.checkedBy}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="approvedBy">Approved By:</label>
            <input
              type="text"
              id="approvedBy"
              name="approvedBy"
              className="form-input"
              value={form.approvedBy}
              onChange={handleInputChange}
            />
          </div>
        </div>

        <div className="form-actions">
          <button type="submit">Submit Form</button>
        </div>
      </form>
    </div>
  );
};

export default PerformaInvoiceForm;
